<template>
  <div>
    <b-navbar v-if="!isHomePageRoute()" class="navbar-static-top fixed-top">
      <!-- <nuxt-link :to="{ name: 'redbag-barcode', params: {barcode: barcode}}"><img  class="back-button" src="~/assets/images/back_button.svg" alt="back"></nuxt-link> -->
      <img v-if="!isHomePageRoute() && incidentId == null" src="~/assets/images/back_button.svg" alt="Back" height="25" @click="goBackOrClose()">
      <nuxt-link :to="headerLogoLink" class="navbar-brand abs-center-x">
        <span v-if="bagName && incidentId">
          <img class="navbar-logo-icon" src="~/assets/images/RedBag_icon_white.svg" alt="RedBag">
          <span style="color:white;font-weight:700;">
            {{ bagName }}
          </span>
        </span>
        <span v-else>
          <img class="navbar-logo" src="~/assets/images/RedBag_logo-white.svg" alt="RedBag">
        </span>
      </nuxt-link>
      <div v-if="1==2" style="font-size:medium;position:absolute;bottom:0px;left:50%;width:200px;transform:translateX(-50%)">
        {{ $route.params.barcode }}
      </div>
    </b-navbar>
    <b-jumbotron v-if="1 == 2 && $route.name == 'redbag-barcode-lockdown'" class="jumbotron" style="top:0px;background-color:#C73D3D;border-radius: 0 !important;margin-bottom:0;">
      <nuxt-link :to="{ name: 'redbag-barcode-lockdown', params: {barcode: barcode}}" role="button" style="text-decoration:none;">
        <div class="jumbotron" style="background-color:white;align-content:center;text-align:center;">
          <img class="" src="~/assets/images/lockdown.svg" alt="Lockdown">
          <div style="font-size:xx-large;color:#6588B1;text-decoration:none;">
            Lockdown
          </div>
        </div>
      </nuxt-link>
    </b-jumbotron>
    <BroadcastMessage />
    <div>
      <nuxt />
      <div v-if="!isAboutPage() && !isLockdownPage() && (broadcastMessage == null || broadcastMessage == '')" style="text-align:center;padding-bottom:1em;">
        <b-button variant="danger" style="text-align:center;" @click="gotoAboutRedBagPage">
          Learn More About RedBag
        </b-button>
      </div>
      <PartnersCarousel v-if="1 == 2" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BroadcastMessage from '~/components/BroadcastMessage.vue'
import PartnersCarousel from '~/components/PartnersCarousel.vue'

export default {
  components: {
    BroadcastMessage,
    PartnersCarousel
  },
  computed: {
    ...mapGetters({
      broadcastMessage: 'BroadcastMessage/getBroadcastMessage',
      broadcastMessageDate: 'BroadcastMessage/getBroadcastMessageDate',
      broadcastMessageFrom: 'BroadcastMessage/getBroadcastMessageFrom',
      roomBroadcastMessage: 'BroadcastMessage/getRoomBroadcastMessage',
      roomBroadcastMessageDate: 'BroadcastMessage/getRoomBroadcastMessageDate',
      roomBroadcastMessageFrom: 'BroadcastMessage/getRoomBroadcastMessageFrom',
      incidentInstructions: 'BroadcastMessage/getIncidentInstructions',
      incidentId: 'BroadcastMessage/getIncidentId',
      bagName: 'BroadcastMessage/getBagName'
    }),
    headerLogoLink () {
      if (this.bagName && this.incidentId) {
        return {
          name: 'redbag-barcode-lockdown',
          params: { barcode: this.barcode }
        }
      } else {
        return {
          name: 'redbag-barcode',
          params: { barcode: this.barcode }
        }
      }
    }
  },
  data () {
    return {
      slide: 0,
      sliding: null,
      barcode: this.$route.params.barcode
    }
  },
  head () {
    return {
      bodyAttrs: {
        class: this.isHomePageRoute() ? 'dashboard-body' : 'test'
      }
    }
  },
  methods: {
    goBackOrClose () {
      if (this.$nuxt?.context?.from?.fullPath === this.$route?.fullPath) {
        window.close()
      }
      console.error(this.$nuxt.context.from)
      this.$router.back()
    },
    onSlideStart (slide) {
      this.sliding = true
    },
    isAboutPage () {
      // alert(this.$route.name)
      return (this.$route.name === 'redbag-barcode-about' || this.$route.name === 'redbag-about')
    },
    isLockdownPage () {
      // alert(this.$route.name)
      return (this.$route.name === 'redbag-barcode-lockdown')
    },
    isHomePageRoute () {
      // alert(this.$route.name)
      return (this.$route.name === 'redbag-barcode' || this.$route.name === 'redbags-overview2')
    },
    onSlideEnd (slide) {
      this.sliding = false
    },
    gotoAboutRedBagPage () {
      // this.$router.push('/redbag/about')
      // this.$router.push('https://getredbag.com/')
      window.location.href = 'https://getredbag.com/'
    }
  }
}
</script>

<style>
  /deep/ html {
    height: -webkit-fill-available;
  }
.navbar-logo{
  width:200px;
  height: 80px;
}

.navbar-logo-icon{
  width: 45px;
  height: 45px;
}

.back-button{
    display: flex;
    height: 40px;
}
/*
    Our blue:   #6588B1
    Our red:    #C73D3D
*/
/* Custom Css */
body {
    padding-top: 80px;
}

body.dashboard-body {
    padding-top: 0px;
}

.card-header-danger {
    background-color: #C73D3D !important;
    background: linear-gradient(60deg,#C73D3D,#C73D3D) !important;
    /*background: linear-gradient(60deg,#ef5350,#C73D3D);*/
}

.card-header-primary {
    background: linear-gradient(60deg,#436996,#6588b1) !important;
}

.carousel-inner img {
    margin: auto;
}

.btn-danger {
    background-color: #C73D3D;
}

.redbagTitle {
    font-weight: bold;
    color: #C73D3D;
}
.abs-center-x {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
}

.redbagHeader{
    font-weight:bold;
    color:white;
    font-family: Calibri, sans-serif;
    font-size:xx-large;
    margin-left:10px;
    text-align:center;
}

.navbar {
    background-color: #C73D3D;
    text-align: center;
    height: 80px;
}

.navbar-redbag {
    background-color: #C73D3D;
    /*background: linear-gradient(60deg,#ef5350,#C73D3D) !important;*/
    text-align: center;
    height: 80px;
}

.hidden{
    display:none;
}

.notificationAnnouncement {
    background-color: #6588B1;
    padding:1rem;
    color:white;
    text-align:center;
    margin-bottom: 2rem;
}

#broadcastMessage {
    background-color: #e9ecef;
    border-radius: 1rem 1rem 1rem 0rem;
    padding: 1rem;
}

#broadcastContainer{
    margin-bottom:0rem;
}

.sponsor-container{
    height:100px;
}

.sponsor-container img {
    max-height:100px;
    max-width:100%;
}
        /*
.sponsor-container img {
    display: block;
    height: 100%;
    width: auto;
}
    */

#contact-us-overlay {
    color: #333;
    position: fixed;
    right: 10px;
    bottom: 0px;
    z-index: 1001;
}
    #contact-us-overlay a {
        color: #333;
        font-weight: bold;
    }

    #contact-us-overlay ul {
        margin: 40px 0px 0px 40px;
        padding: 0px;
        list-style: none;
    }

#contact-us-overlay li {
    float: left;
    margin-left: 8px;
    color: #333;
    background-color: #333;
    padding: 4px 4px 0px 4px;
    -webkit-border-radius: 10px 10px 0px 0px;
    -moz-border-radius: 10px 10px 0px 0px;
    border-radius: 10px 10px 0px 0px;
}

.contact-us-main .contact-us-inner {
    padding-left: 10px;
    font-size:x-large;
    background-image: none;
    background-position: 6px 7px;
    background-repeat: no-repeat;
}

.contact-us-inner {
    background-color: white;
    padding: 5px 8px 4px 8px;
    -webkit-border-radius: 8px 8px 0px 0px;
    -moz-border-radius: 8px 8px 0px 0px;
    border-radius: 8px 8px 0px 0px;
}
</style>

<!--<template>
  <v-app dark>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant="miniVariant"
      :clipped="clipped"
      fixed
      app
    >
      <v-list>
        <v-list-item
          v-for="(item, i) in items"
          :key="i"
          :to="item.to"
          router
          exact
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title v-text="item.title" />
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      :clipped-left="clipped"
      fixed
      app
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-btn
        @click.stop="miniVariant = !miniVariant"
        icon
      >
        <v-icon>mdi-{{ `chevron-${miniVariant ? 'right' : 'left'}` }}</v-icon>
      </v-btn>
      <v-btn
        @click.stop="clipped = !clipped"
        icon
      >
        <v-icon>mdi-application</v-icon>
      </v-btn>
      <v-btn
        @click.stop="fixed = !fixed"
        icon
      >
        <v-icon>mdi-minus</v-icon>
      </v-btn>
      <v-toolbar-title v-text="title" />
      <v-spacer />
      <v-btn
        @click.stop="rightDrawer = !rightDrawer"
        icon
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </v-app-bar>
    <v-content>
      <v-container>
        <nuxt />
      </v-container>
    </v-content>
    <v-navigation-drawer
      v-model="rightDrawer"
      :right="right"
      temporary
      fixed
    >
      <v-list>
        <v-list-item @click.native="right = !right">
          <v-list-item-action>
            <v-icon light>
              mdi-repeat
            </v-icon>
          </v-list-item-action>
          <v-list-item-title>Switch drawer (click me)</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-footer
      :fixed="fixed"
      app
    >
      <span>&copy; 2019</span>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      clipped: false,
      drawer: false,
      fixed: false,
      items: [
        {
          icon: 'mdi-apps',
          title: 'Welcome',
          to: '/'
        },
        {
          icon: 'mdi-chart-bubble',
          title: 'Inspire',
          to: '/inspire'
        }
      ],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'Vuetify.js'
    }
  }
}
</script>
-->
